import logo from '../../../img/logo.svg';

export default function Logo(){

    return (
        <div className="apply-logo">

            <img
                src={logo}
                width={220}
                height={58}
                alt="LearnyLib"
            />

        </div>
    );
}